import { EVENTS } from "../enums/events";

export const dispatchLanguageChangedEvent = (locale: string) => {
  document.dispatchEvent(
    new CustomEvent(EVENTS.EVENT_LISTENER.LANGUAGE_CHANGED, {
      bubbles: true,
      composed: true,
      detail: {
        locale,
      },
    }),
  );
};
